const readPixels = (value: string) => {
  const pixels = Number.parseFloat(value);

  return Number.isNaN(pixels) ? 0 : pixels;
};

// The app header writes its measured height to `--actualHeaderHeight`;
// before it does, the layout's `--headerHeight` holds.
export const getAppHeaderHeight = () => {
  const rootStyles = window.getComputedStyle(document.documentElement);
  const actualHeight = readPixels(
    rootStyles.getPropertyValue('--actualHeaderHeight'),
  );

  return actualHeight > 0
    ? actualHeight
    : readPixels(rootStyles.getPropertyValue('--headerHeight'));
};
